<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="py-8 pr-12">
        <p class="mx-10 mb-6 subtitle-1 font-weight-bold">
          {{ propertyName }}
        </p>
        <v-tabs v-model="tab" vertical>
          <v-tab key="General">
            <v-icon left> mdi-cogs </v-icon>
            General
          </v-tab>
          <v-tab key="Defaults">
            <v-icon left> mdi-text </v-icon>
            Defaults
          </v-tab>
          <v-tab key="Payment">
            <v-icon left> mdi-cash-multiple </v-icon>
            Payment
          </v-tab>
          <v-tab key="Roles" class="d-flex justify-start">
            <v-icon left> mdi-account-multiple </v-icon>
            Roles
          </v-tab>
          <v-tab class="d-flex justify-start">
            <v-icon left> mdi-tag </v-icon>
            Tags
          </v-tab>
          <v-tab class="d-flex justify-start">
            <v-icon left> mdi-tools </v-icon>
            Tools
          </v-tab>
          <v-tab-item class="px-2">
            <v-form v-model="updatePropertyFormValid">
              <v-card flat>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">Property Name</p>
                    <v-text-field
                      v-model="propertyName"
                      prepend-inner-icon="mdi-pencil"
                      placeholder="Spacepack Building"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">
                      Primary email address
                    </p>
                    <v-text-field
                      v-model="email1"
                      prepend-inner-icon="mdi-pencil"
                      readonly
                      disabled
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">
                      Secondary email address
                    </p>
                    <v-text-field
                      v-model="email2"
                      prepend-inner-icon="mdi-pencil"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">Address Line 1</p>
                    <v-text-field
                      v-model="address1"
                      prepend-inner-icon="mdi-map-marker"
                      placeholder="1234 Awesome St., Super City"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">Address Line 2</p>
                    <v-text-field
                      v-model="address2"
                      prepend-inner-icon="mdi-map-marker"
                      placeholder="Metro Manila, Philippines"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="6">
                    <p class="caption font-weight-bold">
                      Primary Contact Number
                    </p>
                    <v-text-field
                      v-model="contactNumber1"
                      prepend-inner-icon="mdi-cellphone"
                      placeholder="+639XXXXXXXXX"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="6">
                    <p class="caption font-weight-bold">
                      Secondary Contact Number
                    </p>
                    <v-text-field
                      v-model="contactNumber2"
                      prepend-inner-icon="mdi-cellphone"
                      placeholder="+639XXXXXXXXX"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  depressed
                  :disabled="!updatePropertyFormValid"
                  @click="finish"
                  >Save</v-btn
                >
                <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-tab-item>
          <v-tab-item class="px-2">
            <v-form v-model="updateDefaultsFormValid">
              <v-card flat>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">Invoice Footer</p>
                    <v-textarea
                      v-model="footer"
                      placeholder="Details to show at the bottom of invoices sent to tenants (Optional)"
                      outlined
                      dense
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
                <p class="caption font-weight-bold">Default rental due date</p>
                <v-row>
                  <v-col class="py-0 pb-2" cols="12" sm="12" md="12">
                    <v-switch
                      v-model="useExactDueDate"
                      class="mt-0"
                      hint="Sets the default rental due date at an exact date of the month, rather than relative to the billing period"
                      persistent-hint
                    >
                      <template v-slot:label> Use exact date </template>
                    </v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="6" md="6">
                    <v-text-field
                      v-model.number="dueDateRental"
                      type="number"
                      prepend-inner-icon="mdi-calendar"
                      prefix="Every"
                      suffix="of the month"
                      outlined
                      dense
                      :disabled="!useExactDueDate"
                      :rules="exactDateRules"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="6" md="6">
                    <p class="caption font-weight-bold"></p>
                    <v-select
                      v-model="dueDateOrder"
                      :items="beforeAfter"
                      suffix="the rental billing period"
                      outlined
                      dense
                      :disabled="!useExactDueDate"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="6" md="6">
                    <v-text-field
                      v-model.number="dueDaysRental"
                      type="number"
                      prepend-inner-icon="mdi-calendar"
                      suffix="days"
                      outlined
                      dense
                      :disabled="useExactDueDate"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="6" md="6">
                    <p class="caption font-weight-bold"></p>
                    <v-select
                      v-model="dueDaysBeforeAfter"
                      :items="beforeAfter"
                      suffix="the rental billing period"
                      outlined
                      dense
                      :disabled="useExactDueDate"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">
                      Automated creation of rental payment requests
                    </p>
                    <v-text-field
                      v-model="advanceRentalPaymentRequestDays"
                      suffix="days in advance"
                      type="number"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-divider class="mb-6"></v-divider>

                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">Notifications</p>
                    <v-switch
                      v-model="notificationDuePayments"
                      hint="Send a notification on the payment due date."
                      persistent-hint
                    >
                      <template v-slot:label> Due payments </template>
                    </v-switch>

                    <v-switch
                      v-model="notificationOverduePayments"
                      hint="Send a notification when payments are overdue. The overdue duration is customized per lease"
                      persistent-hint
                    >
                      <template v-slot:label> Overdue payments </template>
                    </v-switch>

                    <v-switch
                      v-model="notificationUpcomingRentalPayment"
                      hint="Send a notification when the due date of a rental payment request is coming up. The duration is customized per lease"
                      persistent-hint
                    >
                      <template v-slot:label>
                        Upcoming rental payments
                      </template>
                    </v-switch>

                    <v-switch
                      v-model="notificationUpcomingPaymentRequest"
                      hint="Send a notification when the due date of a non-rental payment request is coming up. The duration is customized per payment request"
                      persistent-hint
                    >
                      <template v-slot:label>
                        Upcoming payment requests
                      </template>
                    </v-switch>

                    <v-switch
                      v-model="notificationUpcomingEndOfLease"
                      hint="Send a notification when a lease is about to expire. Default duration is 30 days before the tenant's move out date"
                      persistent-hint
                    >
                      <template v-slot:label> Expiring leases </template>
                    </v-switch>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>

                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <p class="caption font-weight-bold">Forwarding</p>
                    <v-switch
                      v-model="forwardingBCCSecondaryEmail"
                      hint="Notifications tagged to be BCC'd to the property email address will also BCC to the secondary email address"
                      persistent-hint
                    >
                      <template v-slot:label> BCC Secondary email </template>
                    </v-switch>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  depressed
                  :disabled="!updateDefaultsFormValid"
                  @click="finish"
                  >Save</v-btn
                >
                <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-tab-item>
          <v-tab-item class="px-2">
            <v-card flat>
              <v-row>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <span class="caption font-weight-bold align"
                    >Payment Categories</span
                  >
                  <v-row no-gutters>
                    <v-col class="pa-0" cols="12" md="6" sm="12">
                      <v-text-field
                        v-model="newPaymentCategory"
                        outlined
                        dense
                        label="Add New Payment Category"
                        append-icon="mdi-plus"
                        class="mt-2"
                        @click:append="addPaymentCategory()"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-chip-group multiple column class="pt-0">
                    <v-chip
                      v-for="(category, index) in paymentCategories"
                      :key="index"
                      outlined
                      color="primary"
                      class="mr-4"
                      :close="category.deletable"
                      @click:close="removePaymentCategory(category)"
                    >
                      <div class="chip-label">
                        {{ category.text }}
                      </div>
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click="cancel">Close</v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item class="px-2">
            <CustomRole v-if="access.update" ref="CustomRole"></CustomRole>
            <span v-else class="">
              You do not have enough permissions to view this.
            </span>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed @click="saveRoles">Save</v-btn>
              <v-btn color="grey darken-1" text @click="cancel">Close</v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item class="px-2">
            <v-card flat>
              <v-row>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <span class="caption font-weight-bold align"
                    >Property Tags</span
                  >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" class="ml-1" small v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    List of all tags used by the units and groups in the
                    property. <br />
                    A tag can only be deleted if not in use.
                    <span>Tooltip</span>
                  </v-tooltip>
                  <v-chip-group multiple column class="pt-0">
                    <v-chip
                      v-for="(tag, index) in propertyTags"
                      :key="index"
                      outlined
                      color="primary"
                      class="mr-4"
                      close
                      @click:close="deletePropertyTag(tag)"
                    >
                      <div class="chip-label">
                        {{ tag.text }}
                      </div>
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click="cancel">Close</v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item class="px-2">
            <v-card flat>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-btn color="primary" @click="redirectUnitImport"
                    >Units import tool</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-btn color="primary" @click="redirectTenantImport"
                    >Tenant import tool</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-btn color="primary" @click="redirectPDCImport"
                    >PDC import tool</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-btn color="primary" @click="catchUpPropertyPendingRentals"
                    >Catch Up Property Rentals</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-btn color="primary" @click="resendBatchActivation"
                    >Resend all tenant activation</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-btn color="primary" @click="sendBatchStatement"
                    >Send batch monthly statement</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click="cancel">Close</v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <CatchUpPropertyPendingRentals
      ref="catchUpPropertyPendingRentals"
    ></CatchUpPropertyPendingRentals>
  </v-dialog>
</template>

<script>
import CatchUpPropertyPendingRentals from '../payment/CatchUpPropertyPendingRentals.vue'
import CustomRole from '../role/CustomRole.vue'
import { DATEPICKER, dayjs } from '../../util/date'

export default {
  components: {
    CatchUpPropertyPendingRentals,
    CustomRole
  },
  data() {
    return {
      dialog: false,
      loading: false,
      options: {
        color: 'primary',
        width: 800,
        zIndex: 200
      },
      propertyId: null,
      propertyName: '',
      address1: '',
      address2: '',
      contactNumber1: '',
      contactNumber2: '',
      snackbar: false,
      snackbarMessage: '',
      footer: '',
      dueDaysRental: 0,
      dueDaysBeforeAfter: -1,
      dueDateRental: 1,
      dueDateOrder: -1,
      useExactDueDate: false,
      tab: null,
      beforeAfter: [
        { text: 'before', value: -1 },
        { text: 'after', value: 1 }
      ],
      exactDateRules: [
        (v) => (v >= 1 && v < 31) || 'Please select between 1 and 30'
      ],
      updatePropertyFormValid: true,
      updateDefaultsFormValid: true,
      paymentCategories: null,
      newPaymentCategory: null,
      propertyTags: [],
      advanceRentalPaymentRequestDays: 14,
      notificationDuePayments: false,
      notificationOverduePayments: false,
      notificationUpcomingRentalPayment: false,
      notificationUpcomingPaymentRequest: false,
      notificationUpcomingEndOfLease: false
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    access() {
      return this.$root.$roleAccess('property').access
    }
  },
  methods: {
    async open(property) {
      this.dialog = true
      this.propertyId = property.propertyId
      this.propertyName = property.propertyName
      this.email1 = property.email1
      this.email2 = property.email2
      this.address1 = property.address1
      this.address2 = property.address2
      this.contactNumber1 = property.contactNumber1
      this.contactNumber2 = property.contactNumber2
      this.paymentCategories = property.payment_categories_details[0].categories
      this.propertyTags = property.tags
      if (property.defaults) {
        this.footer = property.defaults.footer
        this.dueDaysRental = Math.abs(property.defaults.dueDaysRental) || 0
        this.dueDaysBeforeAfter =
          (property.defaults.dueDaysRental || 0) > 0 ? 1 : -1
        this.dueDateRental =
          property.defaults.exactDueDateRental &&
          property.defaults.exactDueDateRental.date
        this.dueDateOrder =
          property.defaults.exactDueDateRental &&
          property.defaults.exactDueDateRental.order == 'before'
            ? -1
            : 1
        this.useExactDueDate = property.defaults.useExactDueDate
        this.notificationDuePayments = property.defaults.notificationDuePayments
        this.notificationOverduePayments =
          property.defaults.notificationOverduePayments
        this.notificationUpcomingRentalPayment =
          property.defaults.notificationUpcomingRentalPayment
        this.notificationUpcomingPaymentRequest =
          property.defaults.notificationUpcomingPaymentRequest
        this.notificationUpcomingEndOfLease =
          property.defaults.notificationUpcomingEndOfLease
        this.advanceRentalPaymentRequestDays = isNaN(
          property.defaults.advanceRentalPaymentRequestDays
        )
          ? 14
          : property.defaults.advanceRentalPaymentRequestDays
        this.forwardingBCCSecondaryEmail =
          property.defaults.forwardingBCCSecondaryEmail
      } else {
        this.footer = ''
        this.dueDaysRental = 0
      }
    },
    async finish() {
      this.loading = true
      try {
        await this.$store.dispatch('properties/updatePropertyAction', {
          propertyName: this.propertyName,
          email2: this.email2,
          address1: this.address1,
          address2: this.address2,
          contactNumber1: this.contactNumber1,
          contactNumber2: this.contactNumber2,
          defaults: {
            footer: this.footer,
            dueDaysRental: this.dueDaysRental * this.dueDaysBeforeAfter,
            exactDueDateRental: {
              date: this.dueDateRental,
              order: this.dueDateOrder === -1 ? 'before' : 'after'
            },
            useExactDueDate: this.useExactDueDate,
            advanceRentalPaymentRequestDays:
              this.advanceRentalPaymentRequestDays || 0,
            notificationDuePayments: this.notificationDuePayments,
            notificationOverduePayments: this.notificationOverduePayments,
            notificationUpcomingRentalPayment:
              this.notificationUpcomingRentalPayment,
            notificationUpcomingPaymentRequest:
              this.notificationUpcomingPaymentRequest,
            notificationUpcomingEndOfLease: this.notificationUpcomingEndOfLease,
            forwardingBCCSecondaryEmail: this.forwardingBCCSecondaryEmail
          }
        })

        this.dialog = false
        this.loading = false
        window.location.reload()
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err.response.data
          ? err.response.data
          : err.message
        this.loading = false
      }
    },
    async saveRoles() {
      this.loading = true
      const role = this.$refs.CustomRole.selectedRole.role
      try {
        await this.$store.dispatch(
          'roles/updateRole',
          this.$refs.CustomRole.rolesModels[role]
        )
        this.snackbar = true
        this.snackbarMessage = 'Successfully updated user role'
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err.response.data
          ? err.response.data
          : err.message
        this.loading = false
      }

      this.loading = false
    },
    cancel() {
      this.dialog = false
    },
    async addPaymentCategory() {
      const dialogOptions = {
        title: 'Add Payment Category',
        message: 'Are you sure you want to add a new payment category?',
        confirmText: 'CONFIRM'
      }
      this.$root
        .$confirm(dialogOptions)
        .then(async (resolve) => {
          if (resolve) {
            this.loading = true
            await this.$store.dispatch('payments/createPaymentCategory', {
              text: this.newPaymentCategory
            })
            this.loading = false
            window.location.reload()
          }
        })
        .catch((err) => {
          this.snackbar = true
          this.snackbarMessage = err.response.data
            ? err.response.data
            : err.message
          this.loading = false
        })
    },
    async removePaymentCategory(category) {
      const dialogOptions = {
        title: 'Delete Payment Category',
        message:
          'Are you sure you want to delete the selected payment category?',
        confirmText: 'CONFIRM'
      }
      this.$root
        .$confirm(dialogOptions)
        .then(async (resolve) => {
          if (resolve) {
            this.loading = true
            await this.$store.dispatch('payments/deletePaymentCategory', {
              value: category.value
            })
            this.loading = false
            window.location.reload()
          }
        })
        .catch((err) => {
          this.snackbar = true
          this.snackbarMessage = err.response.data
            ? err.response.data
            : err.message
          this.loading = false
        })
    },
    async deletePropertyTag(tag) {
      const dialogOptions = {
        title: 'Delete Property Tag',
        message: 'Are you sure you want to delete this property tag?',
        confirmText: 'CONFIRM'
      }
      try {
        const resolve = await this.$root.$confirm(dialogOptions)
        if (resolve) {
          this.loading = true
          const newTags = await this.$store.dispatch(
            'properties/deletePropertyTagAction',
            {
              propertyId: this.propertyId,
              tag
            }
          )
          this.propertyTags = newTags.data
          this.newUnitTag = null
          this.loading = false
        }
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err.data
        this.loading = false
      }
    },
    redirectTenantImport() {
      this.$router.replace('/tenants/preview-batch-import')
    },
    redirectUnitImport() {
      this.$router.replace('/units/preview-batch-import')
    },
    redirectPDCImport() {
      this.$router.replace('/pdcs/preview-batch-import')
    },
    async catchUpPropertyPendingRentals() {
      this.$root.$setLoading(true)
      const rentalsToMake = await this.fetchPropertyRentalsToCatchUp()

      this.$root.$setLoading(false)
      this.$refs.catchUpPropertyPendingRentals
        .open({
          rentalsToMake
        })
        .then((success) => {
          if (success) window.location.reload()
        })
    },
    async fetchPropertyRentalsToCatchUp() {
      return this.$store.dispatch(
        'payments/fetchPropertyRentalsToCatchUpAction'
      )
    },
    async resendBatchActivation() {
      if (
        await this.$root.$confirm({
          title: 'Send batch activation emails',
          message:
            'Are you sure you want to send activation email to all tenants?'
        })
      ) {
        this.$root.$setLoading(true)
        await this.$store.dispatch('users/resendBatchActivation')

        await this.$root.$confirm({
          title: 'Send batch activation emails',
          message: `The emails have been sent.`,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'primary'
          }
        })
      }
      this.$root.$setLoading(false)
    },
    async sendBatchStatement() {
      if (
        await this.$root.$confirm({
          title: 'Send batch monthly statement',
          message:
            'Are you sure you want to send monthly statement to ALL tenants?'
        })
      ) {
        this.$root.$setLoading(true)
        await this.$store.dispatch('payments/sendBatchMonthlyStatementAction', {
          date: dayjs().format(DATEPICKER),
          sortBy: 'dueDate'
        })

        await this.$root.$confirm({
          title: 'Send batch activation emails',
          message: `The emails have been sent.`,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'primary'
          }
        })
      }
      this.$root.$setLoading(false)
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-size: 13px;
  font-weight: 600;
}
</style>
